import {
  COMMON_SHOW_NOTIFICATION,
  ORDER_DERIVATIVES_PLACE_ORDER,
  ACCOUNT_OTP_VERIFY_SUCCESS,
  GET_SIGN_TOKENCA,
} from 'redux/actions';
import { IAction, INotification, IRequest, IResponse } from 'interfaces/common';
import { IDerivativesPlaceOrderAction } from 'interfaces/actions';
import {
  IDerivativesPlaceOrderParams,
  IDerivativesPlaceOrderResponse,
  IPlaceStopOrderParams,
  IPlaceStopOrderResponse,
  ISignTokenCAResponse,
  ISaveSignTokenCAResponse,
} from 'interfaces/api';
import { IPlaceOrderReducer } from 'interfaces/reducers';
import { OrderKind } from 'constants/enum';
import { ToastType } from 'react-toastify';
import { call, put, takeLeading, select } from 'redux-saga/effects';
import { query } from 'utils/socketApi';
import config from 'config';
import { IState } from 'redux/global-reducers';
import { signTokenCA, registerTokenCA } from '../../../../utils/signTokenCA';
import { addHours } from 'date-fns';

const placeNormalOrder = (params: IDerivativesPlaceOrderParams) => {
  return query(config.apis.derivativesPlaceOrder, params);
};

const placeStopOrder = (params: IPlaceStopOrderParams) => {
  return query(config.apis.placeStopOrder, params);
};

function* doPlaceOrder(request: IRequest<IDerivativesPlaceOrderAction>) {
  const store: IState = yield select((state: IState) => ({
    signTokenCA: state.signTokenCA,
    otp: state.otp,
  }));

  try {
    console.warn('Place order derivativesOrder', request);

    if (store.signTokenCA?.isTokenCA) {
      let data = {
        action:
          request.payload.orderKind === OrderKind.NORMAL_ORDER
            ? 'verifyDerivativesToken'
            : 'verifyDerivativesTokenStopOrder',
        serialToken: store.signTokenCA?.serial,
        timeSign: new Date(),
      };

      if (request.payload.orderKind === OrderKind.NORMAL_ORDER) {
        data['dataSign'] = request.payload.data;
      } else {
        const params = request.payload.data as IPlaceStopOrderParams;
        data['dataSign'] = {
          accountNumber: params.accountNumber,
          code: params.code,
          orderPrice: params.orderPrice,
          orderQuantity: params.orderQuantity,
          sellBuyType: params.sellBuyType,
          orderType: params.orderType,
          stopPrice: params.stopPrice,
          fromDate: params.fromDate,
          toDate: params.toDate,
        };
      }

      if (store.signTokenCA?.serial) {
        const responseSign: ISignTokenCAResponse = yield call(signTokenCA, store.signTokenCA?.serial, data);
        if (responseSign && responseSign.code == 1) {
          let dataSubmit = {
            dataSignTokenCA: responseSign.data,
            ...data,
          };

          const responseSaveSignTokenCA: ISaveSignTokenCAResponse = yield call(registerTokenCA, {
            action:
              request.payload.orderKind === OrderKind.NORMAL_ORDER
                ? 'verifyDerivativesToken'
                : 'verifyDerivativesTokenStopOrder',
            serialToken: store.signTokenCA.serial ?? '',
            dataSign: JSON.stringify(dataSubmit),
            timeSign: addHours(new Date(), 7).toISOString() ?? '',
          });

          if (
            responseSaveSignTokenCA &&
            responseSaveSignTokenCA.status !== 201
          ) {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.ERROR,
                title: 'Order',
                content: 'PLACE_ORDER_FAILED',
                time: new Date(),
              },
            });
          } else {
            if (request.payload.orderKind === OrderKind.NORMAL_ORDER) {
              const response: IResponse<IDerivativesPlaceOrderResponse> = yield call(
                placeNormalOrder,
                request.payload.data
              );

              yield put<IAction<IPlaceOrderReducer>>({
                type: request.response.success,
                payload: {
                  ...response.data,
                  orderKind: request.orderKind,
                  sellBuyType: request.payload.data.sellBuyType,
                },
              });

              yield put<IAction<INotification>>({
                type: COMMON_SHOW_NOTIFICATION,
                payload: {
                  type: ToastType.SUCCESS,
                  title: 'Derivatives Order',
                  content: 'PLACE_ORDER_SUCCESS',
                  contentParams: { orderNumber: response?.data.orderNumber },
                  time: new Date(),
                },
              });
            } else if (
              request.payload.orderKind === OrderKind.STOP_LIMIT_ORDER
            ) {
              const params = request.payload.data as IPlaceStopOrderParams;
              const response: IResponse<IPlaceStopOrderResponse> = yield call(
                placeStopOrder,
                {
                  accountNumber: params.accountNumber,
                  code: params.code,
                  orderPrice: params.orderPrice,
                  orderQuantity: params.orderQuantity,
                  sellBuyType: params.sellBuyType,
                  orderType: params.orderType,
                  stopPrice: params.stopPrice,
                  fromDate: params.fromDate,
                  toDate: params.toDate,
                  macAddress: params.macAddress,
                }
              );

              if (request.response) {
                yield put<IAction<IPlaceOrderReducer>>({
                  type: request.response.success,
                  payload: {
                    ...response.data,
                    orderKind: request.orderKind,
                    sellBuyType: request.payload.data.sellBuyType,
                  },
                });
              }

              yield put<IAction<INotification>>({
                type: COMMON_SHOW_NOTIFICATION,
                payload: {
                  type: ToastType.SUCCESS,
                  title: 'Order',
                  content: 'PLACE_ORDER_SUCCESS',
                  contentParams: { orderNumber: response.data?.id },
                  time: new Date(),
                },
              });
            }
          }
        }
      }
    } else {
      if (request.payload.orderKind === OrderKind.NORMAL_ORDER) {
        const response: IResponse<IDerivativesPlaceOrderResponse> = yield call(
          placeNormalOrder,
          request.payload.data
        );

        yield put<IAction<IPlaceOrderReducer>>({
          type: request.response.success,
          payload: {
            ...response.data,
            orderKind: request.orderKind,
            sellBuyType: request.payload.data.sellBuyType,
          },
        });

        yield put<IAction<INotification>>({
          type: COMMON_SHOW_NOTIFICATION,
          payload: {
            type: ToastType.SUCCESS,
            title: 'Derivatives Order',
            content: 'PLACE_ORDER_SUCCESS',
            contentParams: { orderNumber: response?.data.orderNumber },
            time: new Date(),
          },
        });
      } else if (request.payload.orderKind === OrderKind.STOP_LIMIT_ORDER) {
        const params = request.payload.data as IPlaceStopOrderParams;
        const response: IResponse<IPlaceStopOrderResponse> = yield call(
          placeStopOrder,
          {
            accountNumber: params.accountNumber,
            code: params.code,
            orderPrice: params.orderPrice,
            orderQuantity: params.orderQuantity,
            sellBuyType: params.sellBuyType,
            orderType: params.orderType,
            stopPrice: params.stopPrice,
            fromDate: params.fromDate,
            toDate: params.toDate,
            macAddress: params.macAddress,
          }
        );

        if (request.response) {
          yield put<IAction<IPlaceOrderReducer>>({
            type: request.response.success,
            payload: {
              ...response.data,
              orderKind: request.orderKind,
              sellBuyType: request.payload.data.sellBuyType,
            },
          });
        }

        yield put<IAction<INotification>>({
          type: COMMON_SHOW_NOTIFICATION,
          payload: {
            type: ToastType.SUCCESS,
            title: 'Order',
            content: 'PLACE_ORDER_SUCCESS',
            contentParams: { orderNumber: response.data?.id },
            time: new Date(),
          },
        });
      }
    }
  } catch (error) {
    yield put<IAction<string>>({
      type: request.response.failed,
      payload: error.code || error.message,
    });

    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: request.orderKind,
        content: error.code || error.message,
        contentParams: error.messageParams,
        time: new Date(),
      },
    });
  }

  if (store.otp?.otpToken?.data?.expiryTime == 0) {
    yield put({
      type: ACCOUNT_OTP_VERIFY_SUCCESS,
      payload: {
        token: null,
      },
    });
  }

  yield put({
    type: GET_SIGN_TOKENCA,
    payload: {
      serial: '',
      isTokenCA: false,
    },
  });
}

export default function* watchPlaceOrder() {
  yield takeLeading(ORDER_DERIVATIVES_PLACE_ORDER, doPlaceOrder);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Order/Derivatives/PlaceOrder.ts